import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, WritableSignal, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientSummaryContent } from '../../models/content/patient-summary-content.model';
import { Patient } from '../../models/patient/patient.model';
import { PatientSummaryService } from './patient-summary.service';
import { UserType } from '../../models/enums/user-type.enum';

@Component({
  selector: 'seth-patient-summary',
  standalone: true,
  imports: [AsyncPipe, DatePipe],
  templateUrl: './patient-summary.component.html',
  styleUrl: './patient-summary.component.scss',
})
export class PatientSummaryComponent {

  private _patientSummaryService = inject(PatientSummaryService);

  content$: Observable<PatientSummaryContent> = this._patientSummaryService.getContent();
  patient$: WritableSignal<Patient> = this._patientSummaryService.getPatient();
  showPatientSummary$: WritableSignal<boolean> = this._patientSummaryService.showPatientSummary();
  products$: WritableSignal<string[]> = this._patientSummaryService.getProducts();
  isMobile$: WritableSignal<boolean> = this._patientSummaryService.getIsMobile();
  isUploadDocument$: WritableSignal<UserType> = this._patientSummaryService.getuserType();
}
